export const MINIMUM_POINTS_PER_MINUTE_TO_DISPLAY = 1;